import DeliveryRouteForm from '../../../../components/Purchasing/Cargo/Routes/DeliveryRouteForm'
import DeliveryRouteNewForm from '../../../../components/Purchasing/Cargo/Routes/DeliveryRouteNewForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function DeliveryRouteModal (props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isConfirmed,
    isUpdatable,
  } = props

  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Route Creation'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={!isConfirmed}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      {isNew ? (
        <DeliveryRouteNewForm ref={formRef} {...props} />
      ) : (
        <DeliveryRouteForm ref={formRef} {...props} />
      )}
    </Modal>
  )
}

DeliveryRouteModal.propTypes = {}
DeliveryRouteModal.defaultProps = {}

export default DeliveryRouteModal
